import CustomFilterSelect from "./CustomFilterSelect";

const FilterCalendarDate = (props: any) => {
  const { source, label, variant } = props;
  const DateFilterData = [
    { id: "01", name: "January" },
    { id: "02", name: "February" },
    { id: "03", name: "March" },
    { id: "04", name: "April" },
    { id: "05", name: "May" },
    { id: "06", name: "June" },
    { id: "07", name: "July" },
    { id: "08", name: "August" },
    { id: "09", name: "September" },
    { id: "10", name: "October" },
    { id: "11", name: "November" },
    { id: "12", name: "December" },
  ];

  return (
    <CustomFilterSelect
      source={source}
      label={label}
      choices={DateFilterData}
      before={props?.before != null && props.before !== "" ? props.before : ""}
    />
  );
};

export default FilterCalendarDate;
